export default interface IAttivita {
    Id: number;
    Nome: string;
    Note: string;
    Creation: string;
    Timestamp: string;
}

export const exampleAttivita: IAttivita = {
    Id: 0,
    Nome: '',
    Note: '',
    Creation: '',
    Timestamp: '',
};